import React, { FC } from 'react';
import { useHistory } from 'react-router-dom';

import { IBeacon } from '../../../../../../models/types';
import { paths } from '../../../../../Root/paths';

import Tooltip from '../../../../../../components_/Tooltip';
import DrawerContentItemBeacon from '../../../../../../components_/Drawer/DrawerContentItemBeacon';
import { Button } from 'antd';
import { EditOutlined } from '@ant-design/icons';

interface IProps {
  item: IBeacon;
  setMarkerEditMode: () => void;
}

const Card: FC<IProps> = ({ item, setMarkerEditMode }) => {
  const { macAddress } = item || {};

  const history = useHistory();

  const handleEditClick = () => {
    history.push(paths.map.office.infrastructure.edit(macAddress));
    setMarkerEditMode();
  };

  return (
    <DrawerContentItemBeacon
      beacon={item}
      variant="card"
      action={
        <Tooltip size="s" label="Редактировать">
          <Button type={'text'} icon={<EditOutlined />} onClick={handleEditClick} />
        </Tooltip>
      }
    />
  );
};

export default Card;
